import { ACDB } from "./ACDB";

const acdb = new ACDB();
acdb.init();

export default acdb;
